import { useState } from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { stepForward } from '../../../actions/apartments';
import { allDefined, allValid } from '../../../utils/validation/general';
import Button from '../../../components/Button';
import { useSetStepValidationFailed } from './StepValidationContext';
interface NextStepButtonProps extends WithTranslation {
    doNextStep: any;
    submit: boolean;
    customLabel?: string;
    disabled?: boolean;
    beforeLogin?: boolean;
    setIsEmpty?: any;
    toValidate?: any;
    toCheck?: any;
}
const NextStepButton = ({ t, doNextStep, customLabel, submit, disabled, beforeLogin, setIsEmpty, toValidate, toCheck }: NextStepButtonProps) => {
    const [isLoading, setIsLoading] = useState(false);
    const setStepFailed = useSetStepValidationFailed();
    const handleClick = (arg: any, fields: any) => {
        if (allDefined(arg) && allValid(fields)) {
            setIsEmpty(false);
            setIsLoading(true);
            doNextStep(beforeLogin);
        }
        else {
            setIsEmpty(true);
            setStepFailed(true);
        }
    };
    return (<Button fullWidth variant='contained' style={{
            display: submit ? 'none' : 'flex',
        }} onClick={() => {
            handleClick(toValidate, toCheck);
        }} disabled={disabled} loading={isLoading}>
      {t(customLabel && submit ? customLabel : 'apartment.actions.nextStep')}
    </Button>);
};
const mapDispatchToProps = (dispatch: Dispatch) => ({
    doNextStep: (beforeLogin: boolean) => dispatch(stepForward({ beforeLogin }))
});
export default connect(null, mapDispatchToProps)(withTranslation()(NextStepButton)) as any;
